var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"gray",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.$emit('tologin')}}},[_vm._v("Уже есть аккаунт")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f5af7d2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/elements/RegisterModalFooter.vue
// module id = 101
// module chunks = 6